import events from '../events';
import basketApiClient from './apiClient';
export function addItemToBasket(sku) {
    return {
        sku: '',
        outOfStock: false,
        loading: false,
        quantity: 1,
        error: [],
        $el: {},
        product: {},
        init() {
            const product = JSON.parse(this.$el.closest('[data-product]').dataset.product);
            this.sku = product.sku;
            this.outOfStock = product.outOfStock;
            this.product = product;
        },
        onUpdate(newQuantity) {
            this.quantity = newQuantity;
        },
        submit() {
            this.loading = true;
            const request = {
                sku: this.sku,
                quantity: this.quantity,
            };
            basketApiClient.addItem(request)
                .then(basket => {
                var _a;
                (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', 'add_to_cart', {
                    currency: 'NOK',
                    value: this.product.price,
                    items: [
                        {
                            item_id: this.product.sku,
                            item_name: this.product.title,
                            currency: "NOK",
                            item_category: this.product.categorySlug,
                            price: this.product.price,
                            quantity: this.quantity
                        }
                    ]
                });
                events.onBasketUpdated.trigger({ basket, products: [request] });
            })
                .catch(err => this.error.push(err))
                .finally(() => {
                this.loading = false;
            });
        },
    };
}
;
